import { FilterInput, Filters } from 'components'

import { FilterHookType } from 'types/filters.types'

const ConsentFilter = ({ filter }: { filter: FilterHookType }) => {
  return (
    <Filters filter={filter}>
      <FilterInput
        fieldConfigs={{ datePicker: true }}
        {...{ label: 'Data do consentimento', name: 'datetimeConsent' }}
      />
      <FilterInput
        fieldConfigs={{ textFieldInput: true }}
        {...{ label: 'Nome do banner', name: 'bannerName' }}
      />
      <FilterInput
        fieldConfigs={{ textFieldInput: true }}
        {...{ label: 'URL do banner', name: 'bannerUrl' }}
      />
    </Filters>
  )
}

export default ConsentFilter
